import React from 'react';
import wrapRoot from './wrapRoot';
import wrapPage from './wrapPage';
export const wrapRootElement = wrapRoot;
export const wrapPageElement = wrapPage;
